<template>
  <div class="miscellaneous">
    <vs-button
      color="primary"
      type="filled"
      class="add-doc"
      icon-pack="feather"
      icon="icon-plus"
      title="Add Document"
      @click="activePrompt2 = true"
    ></vs-button>
    <div v-if="data.miscellaneous_document">
      <div
        class="vx-row details mx-1"
        v-for="(miscellaneous_doc,index) in data.miscellaneous_document"
        :key="index"
      >
        <div class="justify-end flex w-full pr-4">
          <vs-button
            type="filled"
            icon-pack="feather"
            icon="icon-edit"
            color="success"
            class="mr-4"
            title="Edit Document"
            @click="getData(index)"
          ></vs-button>
          <vs-button
            type="filled"
            icon-pack="feather"
            icon="icon-trash-2"
            color="danger"
            title="Delete Document"
            @click="deleteConfirm(index)"
          ></vs-button>
        </div>
        <div class="vx-col flex w-full mb-6">
          <label class="font-bold pr-4">Description:</label>
          <p>{{miscellaneous_doc.description}}</p>
        </div>
        <div class="vx-col w-full flex">
          <label class="font-bold pr-4">Document:</label>
          <div class="flex overflow-x-auto">
            <span
              v-for="(doc,dindex) in miscellaneous_doc.docType"
              :key="dindex"
              class="pr-0 image-size"
            >
              <div class="mr-2 mb-4">
                <div v-if="doc.doc_type === 'image'">
                  <a :href="doc.url" target="_blank">
                    <img :src="doc.url" width="100" alt="Image" />
                  </a>
                </div>
                <div v-if="doc.doc_type === 'word'">
                  <a :href="doc.url" target="_blank" class="file">
                    <img
                      width="100"
                      src="../../../../src/assets/images/pages/doc.svg"
                      alt="Document"
                    />
                  </a>
                </div>
                <div v-if="doc.doc_type === 'pdf'">
                  <a :href="doc.url" target="_blank" class="file">
                    <img width="100" src="../../../../src/assets/images/pages/pdf.svg" alt="PDF" />
                  </a>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <vs-prompt
      @cancel="clearValMultiple"
      @accept="saveData"
      @close="close"
      :active.sync="activePrompt2"
      title="Add Miscellaneous"
      accept-text="Save Data"
    >
      <div class="con-exemple-prompt">
        <div class="miscellaneous-data mb-2">
          <label class="font">{{ $t('labels.description') }}</label>
          <vs-textarea
            type="text"
            maxlength="255"
            name="description"
            v-model="description"
            class="w-full mt-1 mb-0"
            :placeholder="$t('labels.description')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm">{{ errors.first('description') }}</span>
        </div>
        <div class="miscellaneous-data">
          <label class="font">{{ $t('labels.select_documents') }}</label>
          <input
            name="url"
            type="file"
            class="vs-input--input normal hasValue mt-1 work"
            required
            accept=".doc, .docx, .pdf"
            multiple
            v-on:change="uploadImageSuccess($event)"
          />
          <span class="text-danger text-sm">{{ errors.first('url') }}</span>
        </div>
        <div class="flex overflow-x-auto upload-img polaroid mt-4" v-if="document_url.length">
          <span v-for="(doc_url,docIndex) in document_url" :key="docIndex" class="pr-0 image-size">
            <div class="mr-2 mb-4">
              <div v-if="fileType[docIndex] === 'image'">
                <a :href="doc_url" target="_blank">
                  <img :src="doc_url" alt="Image" width="100" />
                </a>
              </div>
              <div v-if="fileType[docIndex] === 'word'">
                <a :href="doc_url" target="_blank" class="file">
                  <img width="100" src="../../../../src/assets/images/pages/doc.svg" alt="Document" />
                </a>
              </div>
              <div v-if="fileType[docIndex] === 'pdf'">
                <a :href="doc_url" target="_blank" class="file">
                  <img width="100" src="../../../../src/assets/images/pages/pdf.svg" alt="PDFd" />
                </a>
              </div>
            </div>
          </span>
        </div>
      </div>
    </vs-prompt>
    <vs-prompt
      @cancel="clearData"
      @accept="updateData"
      @close="close"
      :active.sync="activePrompt"
      title="Edit Miscellaneous"
      accept-text="Save Data"
    >
      <div class="con-exemple-prompt miscellaneous-dialog">
        <div class="miscellaneous-data mb-2">
          <label class="font">{{ $t('labels.description') }}</label>
          <vs-textarea
            type="text"
            maxlength="255"
            name="description"
            v-model="description"
            class="w-full mt-1 mb-0"
            :placeholder="$t('labels.description')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm">{{ errors.first('description') }}</span>
        </div>
        <div class="miscellaneous-data">
          <label class="font">{{ $t('labels.select_documents') }}</label>
          <input
            name="url"
            type="file"
            class="vs-input--input normal hasValue mt-1 work"
            required
            accept=".doc, .docx, .pdf"
            multiple
            v-on:change="uploadImageSuccess($event)"
          />
          <span class="text-danger text-sm">{{ errors.first('url') }}</span>
        </div>
        <div class="flex overflow-x-auto upload-img polaroid mt-4" v-if="document_url.length">
          <span v-for="(doc_url,docIndex) in document_url" :key="docIndex" class="pr-0 image-size">
            <div class="mr-2 mb-4">
              <div v-if="fileType[docIndex] === 'image'">
                <a :href="doc_url" target="_blank">
                  <img :src="doc_url" alt="Image" width="100" />
                </a>
              </div>
              <div v-if="fileType[docIndex] === 'word'">
                <a :href="doc_url" target="_blank" class="file">
                  <img width="100" src="../../../../src/assets/images/pages/doc.svg" alt="Document" />
                </a>
              </div>
              <div v-if="fileType[docIndex] === 'pdf'">
                <a :href="doc_url" target="_blank" class="file">
                  <img width="100" src="../../../../src/assets/images/pages/pdf.svg" alt="PDFd" />
                </a>
              </div>
            </div>
          </span>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      data: "",
      document_url: [],
      description: "",
      miscellaneous_id: "",
      showfilter: false,
      fileType: [],
      doc_type: "",
      activePrompt: false,
      activePrompt2: false,
      val: "",
      valMultipe: {
        value1: "",
        value2: ""
      }
    };
  },
  props: ["consultantId", "serviceId", "executiveSummaryData"],
  computed: {},
  mounted() {
    this.getMiscellaneousData();
  },
  methods: {
    async uploadImageSuccess(event) {
      this.$vs.loading();
      const fileData = event.target.files;
      for (let i = 0; i < fileData.length; i++) {
        const file = fileData[i];
        var input = new FormData();
        input.append("directory", "listing");
        input.append("attachment", fileData[i]);
        var response = await this.axios.post("s3/upload", input);
        if (response) {
          let data = response.data.data;
          var file_list = data.url;
          var extension = file_list.split(".").pop();
          if (["png", "jpeg", "jpg", "gif"].includes(extension)) {
            const type = "image";
            this.fileType.push(type);
          }
          if (["doc", "docx"].includes(extension)) {
            const type = "word";
            this.fileType.push(type);
          }
          if (["pdf"].includes(extension)) {
            const type = "pdf";
            this.fileType.push(type);
          }
          this.document_url.push(data.url);
          this.$vs.notify({
            title: "Success.",
            text: response.data.message,
            color: "success",
            position: "top-right"
          });
        } else {
          continue;
        }
      }
      this.$vs.loading.close();
    },
    async getMiscellaneousData() {
      let input = {
        project_id: this.$route.params.id,
        consultant_id: this.consultantId,
        service_id: this.serviceId
      };
      let response = await this.getHTTPPostResponse(
        "miscellaneous-documents/list",
        input
      );
      if (response) {
        var data = response.data;
        this.data = response.data;
        if(data.count !== 0)
        {
          data.miscellaneous_document.forEach(element => {
            var doc_type_arr = [];
            element.document.forEach(el => {
              var doc_url = {
                url: "",
                doc_type: ""
              };
              var file_list = el;
              var extension = file_list.split(".").pop();

              if (["png", "jpeg", "jpg", "gif"].includes(extension)) {
                doc_url.url = el;
                doc_url.doc_type = "image";
              }
              if (["doc", "docx"].includes(extension)) {
                doc_url.url = el;
                doc_url.doc_type = "word";
              }
              if (["pdf"].includes(extension)) {
                doc_url.url = el;
                doc_url.doc_type = "pdf";
              }
              doc_type_arr.push(doc_url);
            });
            element.docType = doc_type_arr;
          });
        }

      }
    },
    async saveData() {
      let input = {
        project_id: this.$route.params.id,
        consultant_id: this.consultantId,
        document: this.document_url,
        description: this.description,
        service_id: this.serviceId
      };
      let response = await this.getHTTPPostResponse(
        "miscellaneous-documents/create",
        input,
        "",
        true
      );
      this.showfilter = false;
      this.document_url = [];
      this.description = "";
      this.fileType = [];
      await this.getMiscellaneousData();
    },
    async clearData() {
      this.showfilter = false;
      this.document_url = [];
      this.fileType = [];
      this.description = "";
      this.miscellaneous_id = "";
      await this.getMiscellaneousData();
    },
    async updateData() {
      let uniqueDoc = [...new Set(this.document_url)];
      let input = {
        project_id: this.$route.params.id,
        consultant_id: this.consultantId,
        document: uniqueDoc,
        description: this.description,
        service_id: this.serviceId
      };
      let response = await this.getHTTPPostResponse(
        "miscellaneous-documents/update/" + this.miscellaneous_id,
        input,
        "",
        true
      );
      this.showfilter = false;
      this.document_url = [];
      this.description = "";
      this.miscellaneous_id = "";
      await this.getMiscellaneousData();
    },
    async getData(index) {
      this.activePrompt = true;
      let response = await this.getHTTPGetResponse(
        "miscellaneous-documents/get/" +
          this.data.miscellaneous_document[index].id,
        "",
        true
      );
      this.fileType = []
      this.document_url = []
      let data = response.data.miscellaneous_document.document;
      data.forEach(el => {
        var file_list = el;
        var extension = file_list.split(".").pop();
        if (["png", "jpeg", "jpg", "gif"].includes(extension)) {
          const type = "image";
          this.fileType.push(type);
        }
        if (["doc", "docx"].includes(extension)) {
          const type = "word";
          this.fileType.push(type);
        }
        if (["pdf"].includes(extension)) {
          const type = "pdf";
          this.fileType.push(type);
        }
        this.document_url.push(el);
      });
      this.description = response.data.miscellaneous_document.description;
      this.miscellaneous_id = response.data.miscellaneous_document.id;
    },
    close() {},
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteDocument
      });
    },
    async deleteDocument() {
      if (this.index < 0) return;
      let index = this.index;
      let url = `miscellaneous-documents/delete/${this.data.miscellaneous_document[index].id}`;
      let input = {};
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getMiscellaneousData();
      }
    },
    // saveData() {
    //   this.$vs.notify({
    //     color: "success",
    //     title: "Accept Selected",
    //     text: "Lorem ipsum dolor sit amet, consectetur"
    //   });
    // },
    clearValMultiple() {
      this.valMultipe.value1 = "";
      this.valMultipe.value2 = "";
    }
  }
};
</script>
<style scoped>
.add-doc {
  float: right;
  top: -71px;
  top: -50px;
  right: 22px;
  position: absolute;
}
.details {
  border: 1px solid #e6e6e6;
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 10px 0px;
}
.miscellaneous-data {
  text-align: left !important;
}
</style>
